import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpComponent } from './help.component';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HelpDetailComponent } from './help-detail/help-detail.component';
import { PinchZoomWrapperComponent } from './pinch-zoom-wrapper/pinch-zoom-wrapper.component';

const routes: Routes = [
  { path: '', component: HelpComponent},
  { path: ':page', component: HelpDetailComponent},
]

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
    MatProgressSpinnerModule,
    PinchZoomWrapperComponent
  ],
  declarations: [HelpComponent, HelpDetailComponent]
})
export class HelpModule { }
